import React from 'react';

export const AdminSkeleton: React.FC<{ rows?: number }> = ({ rows = 4 }) => (
  <div className="animate-pulse space-y-4">
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-20 rounded-xl bg-gray-200 dark:bg-gray-700" />
      ))}
    </div>
    <div className="h-40 rounded-xl bg-gray-200 dark:bg-gray-700" />
  </div>
);

export const AdminNotAuthorized: React.FC = () => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-4">
    <div className="w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-4">
      <svg className="w-6 h-6 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
    </div>
    <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Not authorized</h2>
    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 max-w-xs">
      This dashboard is restricted to admins. If you think this is a mistake, contact support.
    </p>
  </div>
);

export const AdminErrorState: React.FC<{ message?: string; onRetry?: () => void }> = ({
  message = 'Something went wrong loading this data.',
  onRetry,
}) => (
  <div className="flex flex-col items-center justify-center text-center py-16 px-4">
    <div className="w-12 h-12 rounded-full bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-4">
      <svg className="w-6 h-6 text-red-500 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z" />
      </svg>
    </div>
    <p className="text-sm text-gray-500 dark:text-gray-400 max-w-xs">{message}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="mt-4 px-4 py-2 rounded-lg bg-blue-500 dark:bg-blue-400 text-white text-sm font-medium hover:opacity-90 transition-opacity min-h-[44px]"
      >
        Retry
      </button>
    )}
  </div>
);
